import { render, staticRenderFns } from "./saleRanking.vue?vue&type=template&id=5a63aedb&scoped=true&"
import script from "./saleRanking.vue?vue&type=script&lang=js&"
export * from "./saleRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63aedb",
  null
  
)

export default component.exports